/**
 * Host tournament quick-create event presets (structured display + competition).
 */

import {
  EVENT_FORMATS,
  PARTICIPATION_AGE,
  PARTICIPATION_GENDER,
} from "./eventCompetition";
import { getDefaultEventMatchFormatForSport } from "./eventMatchFormat";

/** @typedef {import('./eventCompetition').TournamentEventDefinition} TournamentEventDefinition */

/** @type {readonly ({ id: string } & TournamentEventDefinition)[]} */
export const QUICK_EVENT_PRESETS = Object.freeze([
  {
    id: "mens-singles",
    display: { name: "Men's Singles" },
    competition: {
      format: EVENT_FORMATS.SINGLES,
      participation: { gender: PARTICIPATION_GENDER.MEN, age: PARTICIPATION_AGE.OPEN },
    },
  },
  {
    id: "mens-doubles",
    display: { name: "Men's Doubles" },
    competition: {
      format: EVENT_FORMATS.DOUBLES,
      participation: { gender: PARTICIPATION_GENDER.MEN, age: PARTICIPATION_AGE.OPEN },
    },
  },
  {
    id: "womens-singles",
    display: { name: "Women's Singles" },
    competition: {
      format: EVENT_FORMATS.SINGLES,
      participation: { gender: PARTICIPATION_GENDER.WOMEN, age: PARTICIPATION_AGE.OPEN },
    },
  },
  {
    id: "womens-doubles",
    display: { name: "Women's Doubles" },
    competition: {
      format: EVENT_FORMATS.DOUBLES,
      participation: { gender: PARTICIPATION_GENDER.WOMEN, age: PARTICIPATION_AGE.OPEN },
    },
  },
  {
    id: "mixed-doubles",
    display: { name: "Mixed Doubles" },
    competition: {
      format: EVENT_FORMATS.DOUBLES,
      participation: { gender: PARTICIPATION_GENDER.MIXED, age: PARTICIPATION_AGE.OPEN },
    },
  },
]);

/** @deprecated Use preset ids — display names for tests / hints only */
export const QUICK_EVENT_CHIP_LABELS = Object.freeze(
  QUICK_EVENT_PRESETS.map((p) => p.display.name)
);

/**
 * @param {string} presetId
 */
export function getQuickEventPresetById(presetId) {
  return QUICK_EVENT_PRESETS.find((p) => p.id === presetId) || null;
}

/**
 * Clone preset as a selectable event definition (new client key).
 * @param {string} presetId
 * @param {string | null | undefined} [sportId]
 */
export function eventDefinitionFromPresetId(presetId, sportId) {
  const preset = getQuickEventPresetById(presetId);
  if (!preset) return null;
  return {
    clientKey: preset.id,
    display: { ...preset.display },
    competition: {
      format: preset.competition.format,
      participation: { ...preset.competition.participation },
      matchFormat: getDefaultEventMatchFormatForSport(sportId),
    },
  };
}
